/**
 * Action
 */
import withQuery from 'with-query';
import fetchlib from 'js/fetchlib';
import { SGBC_API_ROOT, SGBC_API_CORS_ROOT } from 'config';

export function search(keyword, electionId, page, pageSize, sorted, filtered) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'search',
        });
        const params = {
            itemsPerPage: pageSize || getState().config.defaultTablePageSize,
            page: page + 1 || 1,
            keyword: keyword,
            electionId: electionId,
            sorted,
        };
        return fetchlib.fetch(dispatch, getState, 'POST', url, params, null, null, null);
    };
}
export function load(id) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'find-by-id',
            id,
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, null, null, null, null);
    };
}
export function generateVoters(electionId) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'generate-voters',
        });
        var data = {
            electionId,
        };
        return fetchlib.fetch(dispatch, getState, 'POST', url, data, null, null, null);
    };
}
export function sendVotingReminder(voterId) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/election`, {
            action: 'sendVotingReminder',
            voterId: voterId,
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, null, null, null, null);
    };
}
export function sendVotingKey(voterId) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/election`, {
            action: 'sendVotingKey',
            voterId: voterId,
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, null, null, null, null);
    };
}
export function save(data) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'create',
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, data, null, null, null);
    };
}
export function update(data) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'update',
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, data, null, null, null);
    };
}
export function remove(id) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/election_v1/voter`, {
            action: 'delete',
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, { id: id }, null, null, null);
    };
}
